import React, { useState, useEffect } from "react";
import axios from "axios";
import { Button, Form } from "semantic-ui-react";

import { MoneyInput } from "components/shared";

import { TermPicker } from "@cb/containers/term/TermPicker";

const FLOW_ESTIMATE = "estimate";
const FLOW_MAX = "max";

const flowOptions = [
  { text: "Estimate", value: FLOW_ESTIMATE },
  { text: "Max amount to loan", value: FLOW_MAX },
].map((o, i) => ({ ...o, key: i }));

export function TermCalculator() {
  const [additionalCost, setAdditionalCost] = useState("");
  const [incomeAmount, setIncomeAmount] = useState("");
  const [zip, setZip] = useState("");
  const [dealerAmount, setDealerAmount] = useState("");
  const [state, setState] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [termData, setTermData] = useState(null);
  const [maxAmountToLoan, setMaxAmountToLoan] = useState("");
  const [flow, setFlow] = useState(FLOW_ESTIMATE);

  useEffect(() => {
    setError(null);
    setTermData(null);
    setMaxAmountToLoan("");
  }, [additionalCost, incomeAmount, zip, dealerAmount, flow]);

  function onEstimateClick() {
    setError(null);
    setLoading(true);

    const req = {
      rto: true,
      monthly_income: incomeAmount,
      additional_down_payment: parseFloat(additionalCost) * 100,
      purchase_reserve_reduction: 0,
      requested_amount: parseFloat(dealerAmount),
      state,
      zip,
    };

    axios
      .post(`/rto-estimator/`, req)
      .then(({ data }) => {
        setTermData({
          plans: [
            { ...data["36"], id: 36 },
            { ...data["48"], id: 48 },
            { ...data["60"], id: 60 },
            { ...data["72"], id: 72 },
          ],
          tax_rate: data.tax_rate,
        });
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        setError(err.response.data.ui_message);
      });
  }

  function getMaxAmountToLoan() {
    setLoading(true);
    setError(null);

    const req = {
      monthly_income: parseFloat(incomeAmount),
    };

    axios
      .post(`/rto-estimator/`, req)
      .then(({ data }) => {
        setMaxAmountToLoan(data);
        setLoading(false);
      })
      .catch((err) => {
        setError(err);
        setMaxAmountToLoan("");
        setLoading(false);
      });
  }

  return (
    <div>
      <Form size="large">
        {/* <Form.Field>
          {flowOptions.map((f) => (
            <Button
              key={f.key}
              onClick={() => setFlow(f.value)}
              content={f.text}
              color={f.value === flow ? "green" : null}
              basic={!f.value === flow}
              type="button"
            />
          ))}
        </Form.Field> */}
        {flow === FLOW_MAX && (
          <Form.Field required>
            <label>Income per month</label>
            <MoneyInput
              value={incomeAmount}
              onChange={(e) => setIncomeAmount(e.target.value)}
            />
          </Form.Field>
        )}
        {flow === FLOW_ESTIMATE && (
          <React.Fragment>
            <Form.Input
              label="Zip"
              required
              value={zip}
              onChange={(e) => setZip(e.target.value)}
            />
            <Form.Field required>
              <label>Total Quote including all materials</label>
              <MoneyInput
                value={dealerAmount}
                onChange={(e) => setDealerAmount(e.target.value)}
              />
            </Form.Field>
            {/* <Form.Field>
              <label>Additional Contract Cost Reduction (optional)</label>
              <MoneyInput
                value={additionalCost}
                onChange={(e) => setAdditionalCost(e.target.value)}
              />
            </Form.Field> */}
          </React.Fragment>
        )}
        {error && (
          <p style={{ margin: "1em 0", fontWeight: "bold", color: "red" }}>
            {error}
          </p>
        )}
        <Button
          content="Submit"
          onClick={() =>
            flow === FLOW_ESTIMATE ? onEstimateClick() : getMaxAmountToLoan()
          }
          loading={loading}
          primary
          disabled={
            flow === FLOW_ESTIMATE ? !zip || !dealerAmount : !incomeAmount
          }
          size="large"
          fluid
        />
      </Form>
      {maxAmountToLoan && (
        <p style={{ fontSize: "1.25em", margin: "1.5em 0" }}>
          The maximum amount Atwood Rentals will loan is{" "}
          <b>
            {new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
            }).format(maxAmountToLoan)}
          </b>
        </p>
      )}
      {termData && (
        <TermPicker
          // additionalCost={this.state.additionalCostInstallation}
          widget
          plans={termData.plans}
          taxRate={termData.tax_rate}
          zip={zip}
        />
      )}
    </div>
  );
}
